import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class BranchAreaUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      area: {},
      bohUsers: [],
      generalManagerUsers: [],
      pricingAreas: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchAreaPricing();
    this.fetchBOH();
    this.fetchGM();
    this.fetchBranchAreaById(this.props.match.params.id);
  }

  async fetchAreaPricing() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-pricing`);
    this.setState({ pricingAreas: areas });
  }

  async fetchBOH() {
    const {
      data: { bohUsers },
    } = await axios.get(`/misc/boh-users`);
    this.setState({ bohUsers });
  }

  async fetchGM() {
    const {
      data: { generalManagerUsers },
    } = await axios.get(`/misc/general-manager-users`);
    this.setState({ generalManagerUsers });
  }

  async fetchBranchAreaById(id) {
    const {
      data: { area },
    } = await axios.get(`/admin-panel/branch-area/${id}`);
    this.setState({ area });
  }

  async updateBranchArea(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        let id = this.props.match.params.id;
        axios
          .patch(`/admin-panel/branch-area/${id}/update`, values)
          .then((result) => {
            message.success(`Berhasil update Area ${values.name}`);
            this.props.history.push(`/home/branch-area`);
          })
          .catch((err) => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Update Area");
      }
    } else {
      message.error("Error Update Area");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Update Branch Area">
        <Spin tip="Sedang mengupdate Area" spinning={this.state.isLoading}>
          <Form onSubmit={(e) => this.updateBranchArea(e)}>
            <FormItem label="Area">
              {getFieldDecorator("name", {
                initialValue: this.state.area ? this.state.area.name : "",
                rules: [{ required: true, message: "Area wajib diisi" }],
              })(<Input />)}
            </FormItem>
            <FormItem label="Branch Internal">
              {getFieldDecorator("internalBranch", {
                initialValue: this.state.area
                  ? this.state.area.internalBranch
                  : "",
                rules: [
                  { required: true, message: "Branch Internal wajib diisi" },
                ],
              })(<Input />)}
            </FormItem>
            <FormItem label="Branch Code">
              {getFieldDecorator("codeBranch", {
                initialValue: this.state.area ? this.state.area.codeBranch : "",
                rules: [{ required: true, message: "Branch Code wajib diisi" }],
              })(<Input />)}
            </FormItem>

            <FormItem label="Pricing Area">
              {getFieldDecorator("areaPricingId", {
                initialValue: this.state.area
                  ? this.state.area.areaPricingId
                  : "",
                rules: [
                  { required: true, message: "Pricing Area wajib diisi" },
                ],
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Pricing Area">
                  {this.state.pricingAreas.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>

            <FormItem label="BOH">
              {getFieldDecorator("userId", {
                initialValue: this.state.area ? this.state.area.userId : "",
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a BOH">
                  {this.state.bohUsers.map((val, index) => (
                    <Option key={index} value={val.userId}>
                      {val.User ? val.User.name : ""}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            <FormItem label="General Manager">
              {getFieldDecorator("gmId", {
                initialValue: this.state.area ? this.state.area.gmId : "",
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a General Manager">
                  {this.state.generalManagerUsers.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val ? val.name : ""}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Update
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(BranchAreaUpdate);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/BranchArea/BranchAreaUpdate.js